import { render, staticRenderFns } from "./address-list.vue?vue&type=template&id=0506e2f0&scoped=true"
import script from "./address-list.vue?vue&type=script&lang=ts"
export * from "./address-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0506e2f0",
  null
  
)

export default component.exports